import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

interface Props {
  preventAvailabilityEnabled: boolean;
}

export function AllowUnavailabilityAndLeave({ preventAvailabilityEnabled }: Props) {
  const [queryAllowUnavailabilityAndLeave] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [allowUnavailabilityAndLeave, setAllowUnavailabilityAndLeave] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryAllowUnavailabilityAndLeave({
      variables: { key: 'allow-unavailability-and-leave' },
    }).then((response) =>
      setAllowUnavailabilityAndLeave(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue
      )
    );
  }, []);

  const saveAllowUnavailabilityAndLeave = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    const newValue = !allowUnavailabilityAndLeave;
    saveAllowUnavailabilityAndLeave
      .run({
        url: `${apiUrl}/vm/admin-console/config`,
        method: 'post',
        data: {
          type: 'allow-unavailability-and-leave',
          value: newValue,
        },
      })
      .then((response) => {
        if (response.ok) {
          setAllowUnavailabilityAndLeave(newValue);
          setSnackbar({
            open: true,
            message: 'Successfully updated',
            variant: 'success',
          });
        } else {
          setSnackbar({
            open: true,
            message: 'Failed to update setting',
            variant: 'error',
          });
        }
      });
  };

  if (!preventAvailabilityEnabled) {
    return null;
  }

  return (
    <Box mt={1} ml={6}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(allowUnavailabilityAndLeave)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'allow unavailability and leave' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Allow Unavailability & Leave
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Allow volunteers to still access the Unavailability & Leave centre to submit leave periods, even when availability submission is prevented.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
